import { Component, OnInit, Inject, EventEmitter, Input, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SelectInputModel, RicercaPraticheService } from 'src/app/services/ricerca-pratiche.service';
import { MatDialog } from '@angular/material';
import { AddTipoAllegatoModalComponent } from 'src/app/core/modals/add-tipo-allegato-modal/add-tipo-allegato-modal.component';


@Component({
  selector: 'app-richiesta-integrazione-modal',
  templateUrl: './richiesta-integrazione-modal.component.html',
  styleUrls: ['./richiesta-integrazione-modal.component.scss']
})
export class RichiestaIntegrazioneModalComponent implements OnInit {

  idTipoDocumento: number = 4;
  currentValue: any;
  @Input() emailValue: number = 1;
  @Input() pecValue: number = 2;
  @Input() tipiAllegati: SelectInputModel[] = [];
  @Output() valueChange = new EventEmitter<any>();
  /*
  
   emailDestinatario : 'test@email.it',
            emailType: {id:1}, 
            emailBody: 'Testo della mail di esempio',
            allegatiDaIntegrare:  [
              //{idTipoAllegato:1, descrizioneTipoAllegato: 'Carta identita', idSoggetto: 908},//cablato va cambiato
              {idTipoAllegato:9999, descrizioneTipoAllegato: 'Fattura psicologo'}
            ]*/


  public integrazioneForm: FormGroup = this.formBuilder.group({
    emailDestinatario: [null, Validators.required],
    emailType: ['1', Validators.required],
    emailBody: [null, Validators.required],
    allegatiDaIntegrare: [[], Validators.required]
  });

  ngOnInit() {
    this.integrazioneForm.get('emailDestinatario').setValue(this.data.richiedentePrincipaleEmailAddress);
    if (this.data.idPratica) this.ricercaPraticaSrv.getHtmlTemplate(this.idTipoDocumento, this.data.idPratica).toPromise().then(val => {
      this.integrazioneForm.get('emailBody').patchValue(val);
    }).catch(err => {
      console.error(err);

    });
  }

  constructor(
    private dialog: MatDialog,
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<RichiestaIntegrazioneModalComponent>,
    private ricercaPraticaSrv: RicercaPraticheService,
    @Inject(MAT_DIALOG_DATA) public data: { header: string, text: string, modalParam: any, tipoAllegato: SelectInputModel[], richiedentePrincipaleEmailAddress: string, idPratica }) {

    //  this.currentValue = this.pecValue;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onValueChange(event: any) {
    this.currentValue = event;
    this.valueChange.emit(this.currentValue);
  }

  getOutPutData() {
    const outputData = this.integrazioneForm.value;
    outputData.allegatiDaIntegrare = outputData.allegatiDaIntegrare.map(value => {
      const tipoDoc = this.data.tipoAllegato.find(val => val.id === value);
      if (tipoDoc) return { idTipoAllegato: tipoDoc.id, descrizioneTipoAllegato: tipoDoc.descrizione };
      else return null;
    });
    outputData.emailType = { id: outputData.emailType };
    outputData.allegatiDaIntegrare = outputData.allegatiDaIntegrare.filter(val => val !== null);
    this.dialogRef.close(outputData);
  }

  addCustomTipoAllegato(listaTipiAllegati: SelectInputModel[]) {
    let msg: string = 'APPLICATION.BACK_OFFICE.GESTIONE_PRATICA.MODAL.ADD_TIPO_ALLEGATO_M';
    let header: string = 'APPLICATION.BACK_OFFICE.GESTIONE_PRATICA.MODAL.ADD_TIPO_ALLEGATO_H';
    const dialogRef = this.dialog.open(AddTipoAllegatoModalComponent, {
      width: '680px',
      data: { text: msg, header }
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result && result.status && result.status === true) {
        listaTipiAllegati.push({ id: Math.max.apply(null, listaTipiAllegati.map(item => item.id)) + 1, descrizione: result.data });
      }
      else {

      }
    });
  }
}
